/**
 * Created by Ning Jiang on 2022-01-14.
 */

import {IdleAnimationController} from "../IdleAnimationController";
import {TimelineLite} from "gsap";
import {MathHelper} from "../../../core/utils/MathHelper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipLayers, Layers} from "../../view/DeadwoodRipLayers";

export class TumbleWeedController extends IdleAnimationController {

    private _isPlaying:boolean = false;

    private _startDelay:number = 20;
    private _intervalRange:[number, number] = [5, 30];
    private _mainTl:TimelineLite | null;

    constructor() {
        super();
    }

    public start():void {
        if(this._isPlaying) {
            return;
        }

        this._isPlaying = true;
        this._mainTl = new TimelineLite();
        this._mainTl.add(() => this.playAnimation(), this._startDelay);
    }

    public stop():void {
        this._isPlaying = false;
        if(this._mainTl) {
            this._mainTl.pause();
            this._mainTl.kill();
        }
        this._mainTl = null;
    }

    private playAnimation():void {
        if(!this._isPlaying) {
            return;
        }

        this._mainTl = new TimelineLite();
        this._mainTl.add(() => this.playWeed());
        this._mainTl.add(() => this.playAnimation(), MathHelper.randomNumberInRange(this._intervalRange[0], this._intervalRange[1], 2));
    }

    private playWeed():void {
        const weed = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("mainIdleWeed"));
        weed.autoUpdate = true;
        if(NolimitApplication.isLandscape) {
            // weed.visible = false;
            weed.position.set(360, 310);
            DeadwoodRipLayers.getLayer(Layers.BACKGROUND_IDLE)?.addChild(weed);
        } else {
            // weed.visible = false;
            weed.scale.set(1.5);
            weed.position.set(360, 550);
            DeadwoodRipLayers.getLayer(Layers.BACKGROUND_IDLE_FOREGROUND)?.addChild(weed);
        }

        const tl = new TimelineLite();
        const animationName = `idle${MathHelper.randomNumberInRange(0, 2)}`;
        tl.add(() => {weed.state.setAnimation(0, animationName, false)});
        // tl.add(() => {weed.visible = true}, 0.01);
        tl.add(() => {
            weed.state.setEmptyAnimations(0);
            weed.parent.removeChild(weed);
            weed.destroy();
        }, weed.spineData.findAnimation(animationName).duration);
    }
}